const mixin = {
    data(){
      return{
        
      };
    },
    methods:{
      
    },
    filters: {
      
    }
  };
  export default mixin;
